<template>
	<FlightDetails
		:arrival-time="formatDate(lastFlightSegment?.Arrival?.Date, { timeStyle: 'short' })"
		:departure-time="formatDate(firstFlightSegment?.Departure?.Date, { timeStyle: 'short' })"
		:number-of-stops="numberOfStops"
		:airline="firstFlightSegment?.Airline"
		:duration="duration"
	/>
</template>

<script setup lang="ts">
import type { VerifiedFlightSegment } from '@/interfaces/offer';
import FlightDetails from './FlightDetails.vue';
import { computed } from 'vue';
import { formatDate } from '@/js/utils/dateTimeUtils';

type Props = {
	flightSegments: VerifiedFlightSegment[] | undefined;
	duration?: number;
};

const { flightSegments, duration } = defineProps<Props>();

const firstFlightSegment = computed(() => flightSegments?.[0]);
const lastFlightSegment = computed(() => flightSegments?.[flightSegments.length - 1]);
const numberOfStops = computed(() => {
	if (!flightSegments) {
		return undefined;
	}
	return Math.max(0, flightSegments.length - 1);
});
</script>
